import { render } from "./UserMarketingSubscriptions.vue?vue&type=template&id=07e4b2d5&scoped=true"
import script from "./UserMarketingSubscriptions.vue?vue&type=script&lang=js"
export * from "./UserMarketingSubscriptions.vue?vue&type=script&lang=js"

import "./UserMarketingSubscriptions.vue?vue&type=style&index=0&id=07e4b2d5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e4b2d5"]])

export default __exports__
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox,QIcon,QTooltip});
